<template>
  <el-tooltip class="item" effect="dark" :open-delay="500" :content="tooltipText" 
    :disabled="(!tooltipText) && (!tooltipTextList || tooltipTextList.length == 0)" placement="top">
    <div slot="content" v-if="!!tooltipTextList">
      <div v-for="(txt, index ) in tooltipTextList" :key="index">
        <span >
          {{txt}}
        </span>
      <br/>
      </div>
    </div>
    <div :class="{'calendar-colorBlock':true,'active':active}" @click="editBlock" @dblclick="editBlockDoubleClick" :style="{backgroundColor:color, width:width+'px', height:height+'px', left:left+'px', top:top+'px', 'font-size':fontSize, 'line-height':lineHeight}">
      <span v-html="title" :style="!!fontColor ? {color: fontColor} : {color:'#ffffff'}"></span>
    </div>
  </el-tooltip>
</template>

<style lang="scss" scoped>
.calendar-colorBlock {
  position: absolute;
  overflow: hidden;
  text-align: center;
  display: block;
  span {
    //color: white;
    display: block;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    word-wrap:break-word;
    max-height: 100%;
  }
  &:hover {
    opacity: 0.9;
    cursor: pointer;
  }
  &.active{
    opacity: 0.9;
  }
}
</style>

<script>
export default {
  data() {
    return {
      isDisplayTooltips: false
    };
  },
  props: {
    starttime: String,
    endtime: String,
    color: String,
    width: Number,
    height: Number,
    left: Number,
    top: Number,
    title: String,
    text: String,
    tooltipText: String,
    tooltipTextList:Array,
    keyValue: Number | String,
    active:Boolean,
    fontSize:String,
    fontColor:String,
    lineHeight:String
  },
  methods: {
    displayTooltips() {},
    editBlock() {
      this.$emit("edit", this.keyValue);
    },
    editBlockDoubleClick(){
      this.$emit("editDoubleClick", this.keyValue);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/calendarColorBlock.vue